import { render, staticRenderFns } from "./ChatWindow.vue?vue&type=template&id=1a8b94b0&"
import script from "./ChatWindow.vue?vue&type=script&lang=ts&"
export * from "./ChatWindow.vue?vue&type=script&lang=ts&"
import style0 from "./ChatWindow.vue?vue&type=style&index=0&id=1a8b94b0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports